import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-togetherapart',
  templateUrl: './togetherapart.component.html',
  styleUrls: ['./togetherapart.component.scss']
})
export class TogetherapartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
